/**
 * Layout - Main application layout wrapper
 */

import React from 'react';
import { motion } from 'framer-motion';

const Layout = ({ children }) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="min-h-screen bg-gray-950"
    >
      {children}
    </motion.div>
  );
};

export default Layout;
